import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollToTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <div className="fixed bottom-4 left-6" style={{zIndex:9999}}>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="bg-orange-500 text-white p-3 rounded-full shadow-lg hover:bg-white hover:text-orange-500 transition duration-300"
                >
                    <FaArrowUp size={24} />
                </button>
            )}
        </div>
    );
};

export default ScrollToTop;
